import { i18n } from '@/locales';
const orderShowTimeOptionList = [];
for (let i = 0; i <= 40; i += 5) {
    orderShowTimeOptionList.push(i);
}
export default orderShowTimeOptionList.map((time) => {
    let text = i18n.t('common.not_use');
    if (time > 0) {
        text = i18n.t('common.minutes_suffix', {
            minutes: time,
        });
    }
    return ({
        text,
        value: time,
    });
});
